import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { ListHealthClaimUserApproveResponse } from './types'
import api from '@/constant/END_POINT'

const fetchListHealthClaimApproveLevel = async () => {
  const response = await httpClientPrivate.get<ListHealthClaimUserApproveResponse>(
    api.backoffice.listHealthClaimApproveLevel,
  )

  return response.data
}

const useListHealthClaimApproveLevel = () => {
  const queryKey = ['useListHealthClaimApproveLevel']
  const queryFn = async () => fetchListHealthClaimApproveLevel()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchListHealthClaimApproveLevel, useListHealthClaimApproveLevel }
